import useResizeEventListener from 'src/hooks/useResizeEventListener.hook'

const useCalcHeightVh = () => {
  const setOneVh = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
  useResizeEventListener(setOneVh)
}
export default useCalcHeightVh
